export const locationColors: Record<string, { fill: string; stroke: string }> =
  {
    l0: { fill: '#1565C0', stroke: '#1565C0' }, // green
    l1: { fill: '#FF9800', stroke: '#FF8F00' }, // bright orange
    other: { fill: '#1565C0', stroke: '#1565C0' },
  };

export const shiftColorPalette = [
  '#00e396', // Green
  '#ff4560', // Red
];

export const TRAVEL_TIME_METRICS_MAP = {
  'Moving Loaded': 'moving_loaded_mins',
  'Moving Unloaded': 'moving_unloaded_mins',
  Idling: 'idling_mins',
  Loading: 'loading_mins',
  Dumping: 'dumping_mins',
} as const;

export const FUEL_USAGE_METRICS_MAP = {
  'Moving Loaded': 'moving_loaded_fuel',
  'Moving Unloaded': 'moving_unloaded_fuel',
  Idling: 'idling_fuel',
  Loading: 'loading_fuel',
  Dumping: 'dumping_fuel',
} as const;

export const MATERIAL_DUMPED_METRIC_MAP = {
  'Site 0': 'L0',
  'Site 1': 'L1',
} as const;

export const DISPATCH_PLAN_STATUS = {
  ACTIVE: 'active',
  DRAFT: 'draft',
} as const;
